import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Questo ebook è davvero per principianti assoluti?',
  a: "Sì. Il Sistema Sigma Smart Visivo è pensato per persone che non hanno mai studiato coreano o qualsiasi altra lingua. Partiamo dall'alfabeto e costruiamo tutto passo a passo."
}, {
  q: 'Posso imparare anche se non ho una buona base linguistica?',
  a: 'Assolutamente. La bellezza del Metodo Visivo è che non dipende dal tuo "talento" precedente. Dipende dalla struttura. Migliaia di persone senza esperienza con le lingue ci sono riuscite.'
}, {
  q: 'Le espressioni e le frasi sono davvero utili, o solo esempi?',
  a: 'Sono autentiche. Ogni frase viene da K-Drama reali, social coreani e situazioni di conversazione genuine. Non sono esempi da manuale — sono ciò che i coreani parlano davvero.'
}, {
  q: "L'ebook include consigli di pronuncia e trucchi per evitare gli errori?",
  a: 'Sì. Tutto il Tomo 2 è dedicato alla pronuncia, con un focus speciale sugli errori che fanno gli italiani. C\'è un\'intera sezione "Errori Mortali da Evitare".'
}, {
  q: 'Quando vedrò progressi reali?',
  a: "Giorno 1: capisci come funziona l'Hangeul. Giorno 5: leggi frasi semplici senza aiuto. Giorno 15: riconosci parole nei K-Drama. Giorno 30: capisci conversazioni base. Giorno 60: hai la tua prima vera conversazione in coreano."
}, {
  q: 'Mi servono altre app o posso usare solo questo sistema?',
  a: 'Questo sistema è completo. Non ti serve nulla di più. Molti studenti scelgono di integrarlo con pratica di speaking (opzionale), ma il PDF ha tutto per iniziare.'
}, {
  q: 'E se non ho 60 minuti ogni giorno?',
  a: 'Non è obbligatorio. 60 minuti è l’ideale, ma puoi farlo al tuo ritmo. Alcuni studenti lo completano in 90 giorni con 30 minuti al giorno. Il sistema si adatta a te.'
}, {
  q: 'C’è supporto se mi blocco?',
  a: 'Sì. Include l’accesso alla community Discord di SIGMA SMART dove ci sono madrelingua coreani e altri studenti che rispondono alle domande. Non sei solo.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Domande frequenti" className="bg-transparent" data-id="element-58" data-mp="2fw27sdkjszjc">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingBottom: "20px",
      paddingTop: "10px"
    }} data-id="element-59" data-mp="2axqzi79wix38">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-60" data-mp="38l96bck05p4l">
          ❓ Domande Frequenti
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-61" data-mp="33nfxscv88j15">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-62" data-mp="2umhtdtgvm9i1" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-63" data-mp="2ul6tw5ugrnwq">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-64" data-mp="3uvhks6u4xu8h">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-65" data-mp="2qnfc3sxg902" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-66" data-mp="7pgtlyg1g41a" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-67" data-mp="cfni7yajvojj">
                  <div className="overflow-hidden" data-id="element-68" data-mp="hh4gdm1ngwwf">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-69" data-mp="mdbn3h1vecff">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}